import { IconNameType } from 'cosmos-components/dist/components/Icon/Icon';

import { SciPagesEnum } from 'src/components/shared/SciPage/types';
import { RedirectErrorRequest } from 'src/components/shared/RedirectErrorModal';

import { PaymentMethodEnum } from './payment.enum';
import { missingTimeSlot, missingDocument } from './payment.messages';

export const MODULE_PREFIX = 'payment';
export const KEY_3DSECURE = '3DSecure';

export const BLOCKING_ERROR_SUBCODES: Record<string, RedirectErrorRequest> = {
    missingTimeSlot: {
        key: 'missing-time-slot',
        title: missingTimeSlot.title,
        description: missingTimeSlot.description,
        button: missingTimeSlot.button,
        targetPage: SciPagesEnum.TimeSlots,
    },
    missingDocument: {
        key: 'missing-document',
        title: missingDocument.title,
        description: missingDocument.description,
        button: missingDocument.button,
        targetPage: SciPagesEnum.Documents,
    },
};

export const PAYMENT_METHOD_ICON_MAPPING: { [key: string]: IconNameType } = {
    [PaymentMethodEnum.DebitCard]: 'b2cCard',
    [PaymentMethodEnum.CreditCard]: 'b2cCard',
    [PaymentMethodEnum.Manual]: 'b2cDollar',
};
